export default __webpack_public_path__ + "static/media/KOD0124-min.ea4712dc.webp";